import React from "react";
import "./App.css";

import MainRouter from "./Routes/MainRouter";

function App() {
  return <MainRouter />;
}

export default App;
